import { Link } from "react-router-dom";
import "./common.css"
import { Avatar } from 'primereact/avatar';

function LeftPanel({
    children
}) {
    return (
        <div className="left-panel">
            <div className="left-panel_container">
                <div className="left-panel_logo">
                    <Link to={"/"} className="logo">
                        <img src="/logo.jpg" height={48} alt="" className="logo_img" />
                    </Link>
                </div>
                <div className="left-panel_menu">
                    {
                        children
                    }
                </div>
                {/* <div className="avatar">
                    <Avatar icon="pi pi-user" className="mr-2" size="small" style={{ backgroundColor: '#f1f1f1', color: '#666', cursor: "pointer" }} />
                </div> */}
            </div>
        </div>
    );
}

export default LeftPanel;